import { EntityStatusTypes } from "@enums/entity-status-types";

export const ENTITY_STATUS_OPTIONS = [
    {
        label: "Active",
        value: EntityStatusTypes.ACTIVE
    },
    {
        label: "Inactive",
        value: EntityStatusTypes.INACTIVE
    }
];